import Person, { names as personNames } from '@/common/interfaces/dto/Person';
import Address, { names as addressNames } from '@/common/interfaces/dto/Address';
import Phone, { names as phoneNames } from '@/common/interfaces/dto/Phone';
import { BrochureItem } from '@/modules/BrochureRequestModule/BrochureRequestModule.types';
import { RecaptchaResponse } from '@/forms/FormElements/Mixins/RecaptchaMixin';

export interface BrochureRequestFormModel extends RecaptchaResponse {
  Person: Person;
  Address: Address;
  Phone: Phone;
  AdditionalBrochures: string[];
  SelectedBrochures: BrochureItem[];
  IsSubscribe?: boolean;
  IsTravelAgent?: boolean,
  IsPastGuest?: boolean,
  AnalyticsPayload?: string;
  DisneyOptin?: boolean
}

const formNames: { [key in keyof BrochureRequestFormModel]: keyof BrochureRequestFormModel } = {
  Person: 'Person',
  Address: 'Address',
  Phone: 'Phone',
  AdditionalBrochures: 'AdditionalBrochures',
  SelectedBrochures: 'SelectedBrochures',
  IsSubscribe: 'IsSubscribe',
  IsTravelAgent: 'IsTravelAgent',
  IsPastGuest: 'IsPastGuest',
};

export const names = {
  ...personNames,
  ...addressNames,
  ...phoneNames,
  ...formNames,
  NewsletterOptin: 'NewsletterOptin',
  DisneyOptin: 'DisneyOptin',
};
